import { DocumentMetadataPropertyTypeEnum as PropertyType, SearchAggregationType, SearchAggregationsAllowedPropertiesForDateHistogramAggregation as DateHistogramProperties, SearchAggregationsAllowedPropertiesForDateRangeAggregation as DateRangeProperties, SearchAggregationsAllowedPropertiesForMetricAggregation as MetricProperties, SearchAggregationsAllowedPropertiesForTermsAggregation as TermsProperties, } from 'shared/domains/apollo/generated/types';
import { dmsToSearchField } from './properties';
/**
 * The fields the search API accepts per aggregation type.
 */
const ALLOWED_FIELDS = {
    [SearchAggregationType.DateHistogram]: new Set(Object.values(DateHistogramProperties)),
    [SearchAggregationType.DateRange]: new Set(Object.values(DateRangeProperties)),
    [SearchAggregationType.Metric]: new Set(Object.values(MetricProperties)),
    [SearchAggregationType.Terms]: new Set(Object.values(TermsProperties)),
    [SearchAggregationType.TopHits]: new Set(Object.values(MetricProperties)),
};
/**
 * Which aggregations make sense for a property's type.
 */
const AGGREGATION_TYPES_BY_PROPERTY_NAME = {
    [PropertyType.Boolean]: [SearchAggregationType.Terms],
    [PropertyType.Date]: [SearchAggregationType.DateHistogram, SearchAggregationType.DateRange],
    [PropertyType.Datetime]: [SearchAggregationType.DateHistogram, SearchAggregationType.DateRange],
    [PropertyType.List]: [SearchAggregationType.Terms],
    [PropertyType.Number]: [SearchAggregationType.Metric, SearchAggregationType.TopHits],
    [PropertyType.Reference]: [SearchAggregationType.Terms],
    [PropertyType.MultiLineText]: [],
    [PropertyType.SimpleText]: [],
};
export function isFieldAllowedForAggregation(aggregationType, field) {
    var _a;
    return Boolean((_a = ALLOWED_FIELDS[aggregationType]) === null || _a === void 0 ? void 0 : _a.has(field));
}
/**
 * The aggregation types a property can be used with.
 */
export function getAggregationTypesForProperty(property) {
    const field = dmsToSearchField(property.name);
    return AGGREGATION_TYPES_BY_PROPERTY_NAME[property.type].filter((aggregationType) => isFieldAllowedForAggregation(aggregationType, field));
}
